export default function() {
  return {
    snackbar: {
      show: false,
      text: '',
      color: 'success', // success | error | warning | info
      timeout: 3000
    },
    status: {
      codeStatus : 0,
      message: '',
      status: ''
    }
  }
}
